import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createModel,
  updateModel,
  deleteModel,
  createFolder,
  updateFolder,
  deleteFolder,
  moveSharedModel,
} from "../../api/models";
import { MODELS_QUERY_KEY } from "../queries/useModels";

export function useCreateModel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, folderId }: { name: string; folderId: number }) =>
      createModel(name, folderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useUpdateModel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      name,
      folderId,
    }: {
      id: number;
      name: string;
      folderId: number;
    }) => updateModel(id, name, folderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useDeleteModel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteModel(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useCreateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, parentId }: { name: string; parentId: number }) =>
      createFolder(name, parentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useUpdateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      name,
      parentId,
    }: {
      id: number;
      name: string;
      parentId: number;
    }) => updateFolder(id, name, parentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useDeleteFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteFolder(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}

export function useMoveSharedModel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, folderId }: { id: number; folderId: number }) =>
      moveSharedModel(id, folderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MODELS_QUERY_KEY });
    },
  });
}
